// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as SendSMSPageSelector from "./SendSMSPageSelector.bs.js";

function SendSMSSearchContainer(Props) {
  return React.createElement(SendSMSPageSelector.make, {});
}

var make = SendSMSSearchContainer;

export {
  make ,
  
}
/* react Not a pure module */
